/**
 * Warm the lazy Recognition (BonusFeed) chunk during the identity/language gate
 * so AppContent's Suspense does not flash a content-frame loader on homepage load.
 */
export const prefetchHomeModule = () => import('../modules/recognition');

/** Routes that render `Recognition.BonusFeed` under AppRootLayout. */
export const isHomeFeedPath = (pathname: string): boolean => {
	if (pathname === '/' || pathname === '') return true;
	return pathname === '/invite' || /^\/bonuses\/[^/]+$/.test(pathname);
};
